import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  ApiService,
  IListData,
  IplayerRouteDetails,
} from 'src/app/shared/services/api/api/api.service';
import { ToasterService } from 'src/app/shared/services/toaster/toaster.service';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Subscription, from } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  switchMap,
} from 'rxjs/operators';
import { Router } from '@angular/router';
import { IDatatableColumn } from '../shared/datatable/datatable-column.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '../shared/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-players',
  templateUrl: './players.component.html',
  styleUrls: ['./players.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayersComponent implements OnInit, OnDestroy {
  @ViewChild('cellTemplate', { static: true }) private _cellTemplate;
  @ViewChild('cellTemplate1', { static: true }) private _cellTemplate1;
  @ViewChild('actions', { static: true }) private _actionsTemplate;
  players = [];

  submitType = 'Add';
  totalPlayers = 0;
  limit = 20;
  skip = 0;
  pageSize = 20;
  search = '';
  page = 1;
  divisionIds = [];
  searchForm: UntypedFormGroup = this._formBuilder.group({
    searchCtrl: new UntypedFormControl(''),
  });
  subscriptions: Subscription[] = [];
  formCompanyQuery: UntypedFormGroup = this._formBuilder.group({
    companyId: ['', [Validators.required]],
    divisionId: ['', [Validators.required]],
  });

  companiesList = [];
  divisionList = [];

  columns: IDatatableColumn[] = [
    {
      name: 'First Name',
      key: 'firstName',
      sortable: true,
      type: 'string',
      style: 'padding-left: 0px; padding-right: 0px',
    },
    {
      name: 'Last Name',
      key: 'lastName',
      sortable: false,
      type: 'string',
      style: 'padding-left: 0px; padding-right: 0px',
    },
    {
      name: 'Email',
      key: 'email',
      width: '20%',
      sortable: false,
      type: 'string',
      style: 'padding-left: 2px; padding-right: 2px; word-break: break-word;',
    },
    {
      name: 'Login Count',
      key: 'loginCount',
      sortable: true,
      type: 'string',
      style: 'padding-left: 0px; padding-right: 0px',
    },
  ];
  constructor(
    private _route: Router,
    private _formBuilder: UntypedFormBuilder,
    private _api: ApiService,
    private _cdr: ChangeDetectorRef,
    private _toast: ToasterService,
    private _modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    this.columns.splice(3, 0, {
      name: 'Company',
      key: 'companyName',
      width: '20%',
      cellTemplate: this._cellTemplate,
      type: 'custom',
      style: 'padding-left: 0px; padding-right: 0px',
    });
    this.columns.splice(4, 0, {
      name: 'Division',
      key: 'divisionName',
      cellTemplate: this._cellTemplate1,
      type: 'custom',
      style: 'padding-left: 0px; padding-right: 0px',
    });
    this.columns.splice(6, 0, {
      name: 'Actions',
      key: 'actions',
      width: '20%',
      cellTemplate: this._actionsTemplate,
      type: 'custom',
      style: 'padding: 2px 0px;',
    });

    this.initRoute();
    // this.getPlayers();
    this.getCompanies();
    this.subscriptions.push(
      this.searchForm.controls.searchCtrl.valueChanges
        .pipe(debounceTime(400), distinctUntilChanged())
        .subscribe((val) => this.onSearchChange(val)),
    );
  }

  refresh(): void {
    this.initRoute();
    this.getCompanies();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  getPlayers(): void {
    const query: {
      // limit: any;
      // skip: any;
      divisions?: any;
      search?: any;
    } = {};

    if (this.search) {
      query.search = this.search;
    }

    if (this.divisionIds.length) {
      query.divisions = this.divisionIds;
    }

    this._api.getPlayers(query).subscribe(
      (data: IListData) => {
        this.players = data.list;
        // console.log(this.players);
        this.totalPlayers = data.totalCount;
        this._cdr.detectChanges();
      },
      (err) => {
        this._toast.showError(err.error.message);
      },
    );
  }

  viewPlayerDetails(playerId: string): void {
    const data: IplayerRouteDetails = {
      companyId: this.formCompanyQuery.get('companyId').value,
      divisionId: this.formCompanyQuery.get('divisionId').value,
      search: this?.search,
      page: this.page,
    };
    this._api.playersActiveRoutes.next(data);
    this._route.navigate(['/players', playerId]);
  }

  deletePlayer(player): void {
    const modalRef = this._modalService.open(ConfirmationModalComponent, {
      backdrop: 'static',
    });
    modalRef.componentInstance.text = 'Are you sure about deleting this?';

    this.subscriptions.push(
      from(modalRef.result)
        .pipe(
          filter((result: boolean) => result),
          switchMap(() => {
            return this._api.deletePlayer(player);
          }),
        )
        .subscribe(
          (): void => {
            this._toast.showSuccess('Player deleted successfully');
            this.getPlayers();
          },
          (err) => {
            this._toast.showError(err.error.message);
          },
        ),
    );
    // this._api.deletePlayer(player).subscribe(
    //   (): void => {
    //     this._toast.showSuccess('Player deleted successfully');
    //     this.getPlayers();
    //   },
    //   (err) => {
    //     this._toast.showError(err.error.message);
    //   },
    // );
  }

  loadPageData(data): void {
    this.skip = data.index;
    this.search = data.search ? data.search : '';
    this.getPlayers();
  }

  loadPage(e, search?): void {
    this.page = e;
    const index = e * this.pageSize - this.pageSize;
    this.loadPageData({ index, countToShow: this.pageSize, search });
  }

  onSearchChange(e): void {
    this.skip = 0;
    this.players = [];
    this.loadPage('1', e);
  }

  getCompanies(): void {
    const inputData = {};
    this._api.getCompanies(inputData).subscribe(
      (data) => {
        this.companiesList = data.list;
      },
      (err) => {
        console.log(err);
      },
    );
  }

  getDivisions(): void {
    const inputData = {};
    this._api.getDivisions(inputData).subscribe(
      (data) => {
        // console.log(data);
        this.divisionList = data.list;
      },
      (err) => {
        console.log(err);
      },
    );
  }

  companySelect(event): void {
    this.divisionList = [];
    // console.log('event', event);
    // const result = this.companiesList.filter(a => a._id === event.value);
    // this.sections = result[0].sections;
    this.getDivisionByID(event.value);
  }

  getDivisionByID(id): void {
    this._api.getDivisionsById(id).subscribe(
      (data) => {
        this.divisionList = data;
      },
      (err) => {
        console.log(err);
      },
    );
  }

  getPlayersByDivisions(): void {
    this.page = 1;
    this.totalPlayers = 0;
    const companyId = this.formCompanyQuery.get('companyId').value;
    const divisionIds = this.formCompanyQuery.get('divisionId').value;
    this.divisionIds = divisionIds;

    if (companyId && divisionIds) {
      this.getPlayers();
    }
  }

  initRoute(): void {
    const data: IplayerRouteDetails = this._api.playersActiveRoutesValue;

    if (data) {
      this.formCompanyQuery.controls.companyId.setValue(data?.companyId);
      this.formCompanyQuery.controls.divisionId.setValue(data?.divisionId);
      this.divisionIds = data?.divisionId;

      if (data?.divisionId) {
        this.getDivisionByID(data?.companyId);
      }

      this.page = data?.page;

      this.loadPage(data?.page, data?.search || null);
    } else {
      this.getPlayers();
    }
  }
}
